!function($) {

  // Add custom JavsScript here
  // --------------------------
  
  var width = $( window ).width();
  
  $(window).resize(function(){
    var width = $( window ).width();
          	var t = $(".hide-1077");

    
    if(width <= 1077){
          	t.css("display","none");
          }else{
            t.css("display","inline");
          }
  });
  
  
$('.openRest1077').on('touchstart click', function(e) {    
    e.stopPropagation(); //stops propagation
    if(e.type == "touchstart") {
        // Handle touchstart event.
      	var t = $(".hide-1077");
      
      	if(t.hasClass("hidden"))
        {
         t.removeClass("hidden"); 
        }else{
          t.addClass("hidden");
        }
    } else if(e.type == "click") {
        // Handle click event.
      	var t = $(".hide-1077");
      
      	if(t.css("display") == "none")
        {
         t.css("display","block");
         $(this).addClass("a");
        }else{
          if(width <= 1077){
          	t.css("display","none");
          }else{
            t.css("display","none");
          }
          $(this).removeClass("a");
        }
    }
});
  
  $(document).on('click','.li', function(){
    var t = $(this);
    
    window.location.assign(t.children('a').attr('href'));
  });

 $('.openRest594').on('touchstart click', function(e) {    
    e.stopPropagation(); //stops propagation
    if(e.type == "touchstart") {
        // Handle touchstart event.
      	var t = $(".hide-594");
      
      	if(t.hasClass("hidden"))
        {
                   $(this).addClass("a");

         t.removeClass("hidden"); 
        }else{
          t.addClass("hidden");
                    $(this).removeClass("a");

        }
    }
});

  // Document ready
  $(function() {
    var width = $( window ).width();
  
  $(window).resize(function(){
    var width = $( window ).width();
  });

  	function truncate(string)
  	{
      if(width >= 1200){
    	if (string.length > 45)
        {
      		return string.substring(0,45)+'...';
    	}else{
      		return string;
    	}
      }else{
        if (string.length > 35)
        {
      		return string.substring(0,35)+'...';
    	}else{
      		return string;
    	}
      }
	};
    
  $(".change").children('.module').children('header').children('h1').html('NAVIGATION');
  $(".change").children('.module').children('.side-nav').html("");
  
  $(".change").children('.module').children('.side-nav').append('<li class="nav-item"><a href="/search">Search</a></li>');
  $(".change").children('.module').children('.side-nav').append('<li class="nav-item active"><a href="https://true-craftware.myshopify.com/pages/about-us">About us</a></li>');
  $(".change").children('.module').children('.side-nav').append('<li class="nav-item active"><a href="https://true-craftware.myshopify.com/pages/contact-us">Contact us</a></li>');
  $(".change").children('.module').children('.side-nav').append('<li class="nav-item active"><a href="https://true-craftware.myshopify.com/blogs/news">Blog</a></li>');

  
  $(".name").each(function(){
    
    var text = $(this).text();
    
    var t = truncate(text);
    $(this).text(t);
  });

  });

}(jQuery);